import React from 'react';
import { useRole } from './RoleContext';

// Blocks direct URL access (e.g. typing /hr) for anyone who isn't superadmin/admin --
// the Sidebar already hides these links, this is the defense-in-depth backstop.
const RequireFullAccess = ({ children }) => {
  const { isFullAccess, loading } = useRole();
  if (loading) return null;
  if (!isFullAccess) {
    return (
      <div style={{ padding: '60px 20px', textAlign: 'center', color: '#999' }}>
        <h2 style={{ color: '#666' }}>🔒 Access Restricted</h2>
        <p>You don't have access to this page. Contact your Admin if you believe this is a mistake.</p>
      </div>
    );
  }
  return children;
};

export default RequireFullAccess;
